const SpinnerOverlay = {
  init: () => {
    const buttonElements = document.querySelectorAll('[data-spinner=true]');

    buttonElements.forEach((buttonElement: HTMLElement) => {
      buttonElement.addEventListener('click', function () {
        const overlay = document.getElementById('spinner-overlay');
        overlay.classList.remove('hidden');
      });
    });
  },
};

export default SpinnerOverlay;
